export function downloadGoiVcard() {
  const vcard = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "N:고이장례연구소;;;;",
    "FN:고이장례연구소",
    "ORG:고이장례연구소",
    "TEL;TYPE=WORK,VOICE:1666-9784",
    "END:VCARD",
  ].join("\r\n");

  const blob = new Blob([vcard], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "goi-funeral.vcf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
